<template>
  <div>
    <h3>List of all users</h3>
    <div class="row">
      <div class="form-group col-lg-10">
        <!-- <label for="exampleInputEmail1">Search</label> -->
        <input
          type="email"
          class="form-control"
          placeholder="Search users by roles or names"
          v-model="userSearchInput"
          @keyup="userSearch"
        />
      </div>
      <div class="form-group col-lg-2">
        <button
          class="btn add-new btn-primary waves-effect waves-float waves-light float-right"
          tabindex="0"
          aria-controls="DataTables_Table_0"
          type="button"
          data-toggle="modal"
          data-target="#user-modal"
          data-v-5845443d=""
        >
          <span data-v-5845443d="">Add New User</span>
        </button>
      </div>
    </div>
    <vue-good-table
      mode="remote"
      v-on:page-change="onPageChange"
      v-on:per-page-change="onPerPageChange"
      :totalRows="totalRecords"
      :pagination-options="{
        enabled: true,
        perPageDropdown: [10, 20, 30, 40, 50, 100],
        dropdownAllowAll: false,
      }"
      :rows="rows"
      :columns="columns"
      :sort-options="{
        enabled: false,
      }"
    >
      <template #table-row="props">
        <div v-if="props.column.field == 'username'">
          <div class="d-flex justify-content-left align-items-center">
            <div class="avatar-wrapper">
              <div class="avatar bg-light-info mr-1">
                <div class="avatar-content">CF</div>
              </div>
            </div>
            <router-link
              :to="{ name: 'user-show', params: { user: props.row.id } }"
              class="d-flex flex-column"
              v-slot="{ href, route, navigate }"
            >
              <a :href="href" data-toggle="tooltip" data-placement="top" target="__self">
                <div class="user_name text-body text-truncate">
                  <div class="fw-bolder text-sm">{{ props.row.name }}</div>
                </div>
                <div class="emp_post text-muted text-sm">{{ props.row.email }}</div>
              </a>
            </router-link>
          </div>
        </div>
        <div v-else-if="props.column.field == 'envelops_count'">
          <p v-for="(count, label) in props.row.envelops_count" class="mb-0">
            {{ label }}: {{ count }}
          </p>
        </div>
        <div v-else-if="props.column.field == 'mail_types_count'">
          <p v-for="(count, label) in props.row.mail_types_count" class="mb-0">
            {{ label }}: {{ count }}
          </p>
        </div>
        <div v-else-if="props.column.field == 'roles'">
          <div
            v-if="props.row.roles == 'Administrator'"
            class="d-flex align-items-center"
          >
            <vue-feather size="18" class="text-primary mr-50" type="database" />
            Administrators
          </div>
          <span
            v-else-if="props.row.roles == 'Business User'"
            class="d-flex align-items-center"
          >
            <vue-feather size="18" class="text-primary mr-50" type="user" /> Business User
          </span>
          <span v-else-if="props.row.roles == 'Author'" class="d-flex align-items-center">
            <vue-feather size="18" class="text-primary mr-50" type="edit-2" /> Author
          </span>
          <span
            v-else-if="props.row.roles == 'DIY User'"
            class="d-flex align-items-center"
          >
            <vue-feather size="18" class="text-primary mr-50" type="user" /> DIY User
          </span>
          <span v-else-if="props.row.roles == 'client'" class="d-flex align-items-center">
            <vue-feather size="18" class="text-primary mr-50" type="user" /> Client
          </span>
          <span v-else class="d-flex align-items-center">
            <vue-feather size="18" class="text-primary mr-50" type="user" />
            <span v-if="props.row.roles instanceof Object">
              {{ props.row.roles[0].display_name }}
            </span>
          </span>
        </div>
        <!-- <div v-else-if="props.column.field == 'actions'">
                    <a class="action-delete mr-1 text-danger" data-toggle="tooltip" data-placement="top" title="Delete Dispute">
                        <vue-feather class="action_iconic" type="trash-2" />
                    </a>
                </div> -->
        <div v-else-if="props.column.field == 'email_verified_at'">
          <button
            v-if="_.isNull(props.row.email_verified_at)"
            type="button"
            class="btn btn-sm btn-outline-primary waves-effect waves-float waves-light"
            @click="updateEmailStatus(props.row.id, 1)"
          >
            Verify
          </button>
          <template v-else>
            <button
              :id="`email-verified-at-${props.row.id}`"
              type="button"
              class="btn btn-sm btn-outline-primary waves-effect waves-float waves-light mr-50"
            >
              Yes
            </button>
            <b-popover
              :target="`email-verified-at-${props.row.id}`"
              placement="top"
              triggers="hover"
              :html="true"
            >
              <template #title> Email Verified At </template>
              <div class="row">
                <div class="col-12">
                  {{ props.row.email_verified_at }}
                </div>
              </div>
            </b-popover>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger waves-effect waves-float waves-light"
              @click="updateEmailStatus(props.row.id, 0)"
            >
              UnVerify
            </button>
          </template>
        </div>
        <div v-else>
          <span class="text-sm">{{ props.formattedRow[props.column.field] }}</span>
        </div>
      </template>
    </vue-good-table>
    <create-new-user></create-new-user>
  </div>
</template>
<script>
import { VueGoodTable } from "vue-good-table-next";
import moment from "moment";
import { useLocalizationStore } from "../../stores/LocalizationStore.js";
import { useSettingStore } from "../../stores/SettingStore.js";
import "vue-good-table-next/dist/vue-good-table-next.css";
import axios from "axios";
import { ref, reactive } from "vue";
import CreateNewUser from "./admin_user_view/layout/CreateNewUser.vue";
import debounce from "lodash/debounce";
import { BPopover } from "bootstrap-vue-3";
import Swal from "sweetalert2";
import { fix } from "mathjs";
export default {
  name: "UserTable",
  components: {
    VueGoodTable,
    CreateNewUser,
    BPopover,
  },
  setup() {
    let limit = ref(10);
    let currentPage = "/administrant/dashboard/userslist";
    let searchLink = "";
    return {
      currentPage,
      fix: fix,
      searchLink,
      settingStore: useSettingStore(),
      localizationStore: useLocalizationStore(),
      limit,
      _: _,
    };
  },
  created() {
    this.settingStore.fetchSetting();
  },
  mounted() {
    const route = this.$router.resolve({
      name: "admin-users-list",
    });
    let uri = route.href;
    this.currentPage = uri;
    this.getUserList(this.currentPage, null);
  },
  methods: {
    getUserList(uri, page) {
      let url;
      if (page == null || page == undefined) {
        url = uri + "?page=1&limit=" + this.limit;
      } else {
        url = uri + "&limit=" + this.limit;
      }
      this.currentPage = url;
      axios
        .get(url)
        .then(({ data }) => {
          this.users = data.data;
          this.totalRecords = this.users.total;
          this.rows = data.data.data;
        })
        .catch();
    },
    userSearch: debounce(function () {
      let url;
      const route = this.$router.resolve({
        name: "admin-search-user",
      });
      let usersSearchuri = route.href;
      if (this.searchLink.length <= 0) {
        url = usersSearchuri + "?page=1&limit=" + this.limit;
      } else {
        url = this.searchLink + "&limit=" + this.limit;
      }
      if (this.userSearchInput != "") {
        axios.get(`${url}&searchvalue=${this.userSearchInput}`).then(({ data }) => {
          if (data.data != null) {
            this.users = data.data;
            this.totalRecords = data.data.total;
            this.rows = data.data.data;
          } else {
            this.getUserList(this.currentPage);
          }
        });
      } else {
        this.searchLink = "";
        this.getUserList(this.currentPage);
      }
    }, 1000),
    onPageChange(params) {
      var global_data = this.users;
      if (params.prevPage < params.currentPage) {
        this.currentPage = global_data.next_page_url;
        if (this.userSearchInput != "") {
          this.searchLink = global_data.next_page_url;
          this.userSearch();
        } else {
          this.getUserList(global_data.next_page_url, true);
        }
      } else {
        this.currentPage = global_data.prev_page_url;
        if (this.userSearchInput != "") {
          this.searchLink = global_data.prev_page_url;
          this.userSearch();
        } else {
          this.getUserList(global_data.prev_page_url, true);
        }
      }
    },
    onPerPageChange(params) {
      let global_data = this.users;
      let links = global_data.links,
        activeLink;
      const route = this.$router.resolve({
        name: "admin-users-list",
      });
      let uri = route.href;
      links.forEach((element) => {
        if (element.active == true) {
          activeLink = element.url;
        } else {
          activeLink = uri + "?page=1";
        }
      });
      this.limit = params.currentPerPage;
      if (this.userSearchInput != "") {
        this.searchLink = global_data.prev_page_url;
        this.userSearch();
      } else {
        this.getUserList(activeLink, true);
      }
    },
    updateEmailStatus(userId, status) {
      const $this = this;
      Swal.fire({
        title:
          status == 1
            ? "Are you sure you want to verify this user?"
            : "Are you sure you want to Un Verify this user?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: status == 1 ? "Verify!" : "Un Verify!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(function (result) {
        if (result.value) {
          const route = $this.$router.resolve({
            name: "update-email-status",
            params: {
              user: userId,
            },
          });
          axios
            .post(route.href, {
              status: status,
            })
            .then(function (response) {
              if (response.data.error == true) {
                toastr.error(response.data.message, "Error!");
                return;
              }
              let userIndex = _.findIndex($this.users.data, { id: userId });
              $this.users.data[userIndex].email_verified_at =
                response.data.data.email_verified_at;
              let rowIndex = _.findIndex($this.rows, { id: userId });
              $this.rows[rowIndex].email_verified_at =
                response.data.data.email_verified_at;
              toastr.success(response.data.message, "Success!");
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
    },
  },
  data() {
    return {
      userSearchInput: "",
      users: reactive({}),
      totalRecords: ref(0),
      columns: [
        {
          label: "User ID",
          field: "id",
          thClass: "text-sm",
          width: "80px",
          html: true,
        },
        {
          label: "Name",
          field: "username",
          thClass: "text-sm",
          width: "auto",
          html: true,
        },
        {
          label: "Total Mails Sent",
          field: "mails_count",
          thClass: "text-sm",
          width: "auto",
          html: true,
        },
        {
          label: "Total Mails Cost",
          field: function (row) {
            return fix(row.total_cost_of_mails, 2).toFixed(2);
          },
          thClass: "text-sm",
          width: "auto",
          html: true,
        },
        {
          label: "No Of Envelops",
          field: "envelops_count",
          thClass: "text-sm",
          width: "auto",
          html: true,
        },
        {
          label: "Mail Types Count",
          field: "mail_types_count",
          thClass: "text-sm",
          width: "auto",
          html: true,
        },
        {
          label: "Roles",
          field: "my_role",
          thClass: "text-sm",
          html: true,
        },
        {
          label: "Plan",
          field: "my_plan",
          thClass: "text-sm",
          width: "auto",
          html: true,
        },
        // {
        //     label: 'Total Revenue',
        //     field: 'total_revenue',
        //     thClass:"text-sm",
        //     width: '160px',
        // },

        // {
        //     label: 'Number of Reports Requested',
        //     field: 'number_of_reports_requested',
        //     thClass:"text-sm",
        //     width:'170px',
        //     html:true
        // },
        {
          label: "Reports Submited",
          field: "number_of_reports_submited",
          thClass: "text-sm",
          width: "170px",
          html: true,
        },
        // {
        //     label: 'BS Contract Not Signed',
        //     field: 'bs_contract_no_signed',
        //     thClass:"text-sm",
        //     width:'170px',
        //     html:true
        // },
        {
          label: "Team Members",
          field: "team_members",
          thClass: "text-sm",
          width: "140px",
          html: true,
        },
        {
          label: "Family Members",
          field: "family_members_count",
          thClass: "text-sm",
          width: "120px",
          html: true,
        },
        {
          label: "Is Email Verified",
          field: "email_verified_at",
          thClass: "text-sm",
          width: "220px",
          html: true,
        },
        // {
        //     label: 'Actions',
        //     field: 'actions',
        //     thClass: "text-sm",
        //     width: '120px',
        //     html: true
        // }
      ],

      rows: [],
    };
  },
};
</script>
<style scoped>
.user_table_class {
  font-size: 14px !important;
  font-weight: bolder !important;
}

.vgt-table thead th span {
  font-size: 12px !important;
  font-weight: bolder !important;
}
</style>
